import { OrganisationActions } from '@/modules/organisation/store/actions';
import { OrganisationGetters } from '@/modules/organisation/store/getters';
import { OrganisationMutations } from '@/modules/organisation/store/mutations';
import {
  OrganisationState,
  IOrganisationState
} from '@/modules/organisation/store/state';
import { IRootState } from '@/store/state';
import { Module, Store, StoreOptions } from 'vuex';

export const OrganisationModuleStore: IOrganisationModuleStore = {
  state: OrganisationState,
  actions: OrganisationActions,
  getters: OrganisationGetters,
  mutations: OrganisationMutations
};

/**
 * --------------------------------------------------
 *	Organisation Store Interface
 * --------------------------------------------------
 **/
export interface IOrganisationModuleStore
  extends Module<IOrganisationState, IRootState> {}
